export const ADD_FILES = 'avt/upload/ADD_FILES';
export const REMOVE_UPLOAD = 'avt/upload/REMOVE_UPLOAD';
export const INIT_UPLOAD = 'avt/upload/INIT_UPLOAD';
export const UPLOAD_STARTED = 'avt/upload/UPLOAD_STARTED';
export const UPLOAD_PROGRESS = 'avt/upload/UPLOAD_PROGRESS';
export const UPLOAD_COMPLETED = 'avt/upload/UPLOAD_COMPLETED';
export const UPLOAD_FAILED = 'avt/auth/UPLOAD_FAILED';
export const ADDED = 'added';
export const INITIALIZED = 'initialized';
export const UPLOADING = 'uploading';
export const UPLOADED = 'uploaded';
export const FAILED = 'failed';

export const addFile = (file, siteId, modelId) => ({
  type: ADD_FILES,
  files: [file],
  siteId,
  modelId,
});

export const addFiles = (files, siteId, modelId) => ({
  type: ADD_FILES,
  files,
  siteId,
  modelId,
});

export const removeUpload = (id) => ({
  type: REMOVE_UPLOAD,
  id,
});

export const initUpload = (upload) => ({
  type: INIT_UPLOAD,
  id: upload.id,
  org: upload.org,
  siteId: upload.siteId,
  arkitSupported: upload.arkitSupported,
  comment: upload.comment,
  rootFile: upload.rootFile,
  modelName: upload.modelName,
  copyMappings: upload.copyMappings,
  mappingsFromVersion: upload.mappingsFromVersion,
});

export const uploadStarted = (id, versionId) => ({
  type: UPLOAD_STARTED,
  id,
  versionId,
});

export const uploadProgress = (id, progress) => ({
  type: UPLOAD_PROGRESS,
  id,
  progress,
});

export const uploadCompleted = (id) => ({
  type: UPLOAD_COMPLETED,
  id,
});

export const uploadFailed = (id, errors) => ({
  type: UPLOAD_FAILED,
  id,
  errors,
});
